import { MapPin, Phone, Mail } from "lucide-react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { company, showContactHours, showMap } from "@/mocks/home";

export default function Contact() {
  return (
    <section id="contactos" className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-container px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="Contactos"
          title="Fale connosco. Estamos por perto."
          description="Estamos disponíveis para esclarecer qualquer dúvida e apresentar uma proposta à medida do seu condomínio."
        />

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          <Reveal className="h-full">
            <div className="flex h-full flex-col items-start rounded-lg border border-background-200 bg-background-50 p-7">
              <div className="flex h-14 w-14 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <MapPin className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">Localização</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{company.location}</p>
              <p className="mt-1 text-sm text-foreground-500">Vamos até ao seu condomínio — reuniões por marcação.</p>
            </div>
          </Reveal>

          <Reveal delay={90} className="h-full">
            <div className="flex h-full flex-col items-start rounded-lg border border-background-200 bg-background-50 p-7">
              <div className="flex h-14 w-14 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <Phone className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">Telemóvel / WhatsApp</h3>
              <a
                href={company.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contactar a Porta31 por WhatsApp"
                className="mt-2 cursor-pointer text-sm font-medium text-foreground-700 transition-colors duration-300 hover:text-primary-600"
              >
                {company.phoneDisplay}
              </a>
              {/* Horário de atendimento OCULTO (empresa nova, sem horário definido).
                  Para voltar a mostrar: mude `showContactHours` para `true` em src/mocks/home.ts */}
              {showContactHours && (
                <p className="mt-1 text-sm text-foreground-500">{company.hours}</p>
              )}
            </div>
          </Reveal>

          <Reveal delay={180} className="h-full">
            <div className="flex h-full flex-col items-start rounded-lg border border-background-200 bg-background-50 p-7">
              <div className="flex h-14 w-14 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <Mail className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">Email</h3>
              <a
                href={`mailto:${company.email}`}
                aria-label="Enviar email para a Porta31 Condomínios"
                className="mt-2 cursor-pointer break-all text-sm font-medium text-foreground-700 transition-colors duration-300 hover:text-primary-600"
              >
                {company.email}
              </a>
              <p className="mt-1 text-sm text-foreground-500">Respondemos em até 1 dia útil.</p>
            </div>
          </Reveal>
        </div>

        {/* Mapa OCULTO (empresa ainda sem escritório fixo com morada).
            Para voltar a mostrar: mude `showMap` para `true` em src/mocks/home.ts
            e ajuste a morada abaixo. */}
        {showMap && (
          <Reveal delay={160}>
            <div className="mt-8 overflow-hidden rounded-lg border border-background-200">
              <iframe
                title="Mapa de Vila Nova de Famalicão"
                src="https://www.google.com/maps?q=Vila%20Nova%20de%20Famalic%C3%A3o%2C%20Portugal&output=embed"
                width="100%"
                height="340"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="block h-[300px] w-full md:h-[340px]"
                aria-label="Localização da Porta31 em Vila Nova de Famalicão"
              />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}